import { render, staticRenderFns } from "./AnchorDetailsPanel.vue?vue&type=template&id=67c897a0&scoped=true"
import script from "./AnchorDetailsPanel.vue?vue&type=script&lang=js"
export * from "./AnchorDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./AnchorDetailsPanel.vue?vue&type=style&index=0&id=67c897a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c897a0",
  null
  
)

export default component.exports